import {HtmlRenderer, Parser} from 'commonmark';

function renderMarkdown(raw) {
    const reader = new Parser();
    const parsed = reader.parse(raw);
    const writer = new HtmlRenderer();
    return writer.render(parsed);
}

export default renderMarkdown;
